module.exports = __webpack_public_path__ + "static/img/logo.a155bc71.png";